var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaypal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.245,
    height: 35.728,
    viewBox: "0 0 30.245 35.728",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-paypal",
    "data-name": "Icon awesome-paypal",
    d: "M8.776,23.063C8.5,24.576,7.4,31.627,7.082,33.62c-.024.142-.079.2-.236.2H.968a.957.957,0,0,1-.953-1.1l4.617-29.3A1.6,1.6,0,0,1,6.207,2.092c12,0,13.007-.291,16.071.9,4.735,1.836,5.168,6.263,3.466,11.053-1.694,4.932-5.712,7.051-11.037,7.114-3.419.055-5.475-.551-5.932,1.907ZM28.132,11.727c-.142-.1-.2-.142-.236.1a18.438,18.438,0,0,1-.693,2.647c-3.143,8.965-11.857,8.185-16.111,8.185a.793.793,0,0,0-.859.741C8.453,34.463,8.1,36.771,8.1,36.771a.839.839,0,0,0,.835,1.016h5a1.413,1.413,0,0,0,1.371-1.174c.055-.425-.087.481,1.134-7.193.362-1.733,1.127-1.552,2.308-1.552,5.594,0,9.958-2.269,11.258-8.847.512-2.742.362-5.625-1.875-7.3Z",
    transform: "translate(-0.006 -2.06)",
    fill: "#022873"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.185b16f86b2e10da20147e061ba42d42.svg";
export { ForwardRef as ReactComponent };